<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="设备序列号">
                        <el-input v-model="searchForm.deviceId" placeholder="请输入设备序列号" clearable></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="getTemplateList" icon="el-icon-search">查询</el-button>
                        <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="deviceRecordList" height="70vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceId" label="设备序列号" align="center" />
                    <el-table-column prop="sampleName" label="样品名" align="center" />
                    <el-table-column prop="cabinetId" label="柜号" align="center" />
                    <el-table-column prop="storedHours" label="预存时间" align="center" />
                    <el-table-column prop="operaInCabTime" label="入柜时间" align="center" />
                    <el-table-column prop="operaOutCabTime" label="出柜时间" align="center" />
                    <el-table-column prop="operaInCabName" label="入柜操作人" align="center" />
                    <el-table-column prop="operaOutCabName" label="出柜操作人" align="center" />
                    <el-table-column prop="operationType" label="操作类型" align="center">
                        <template #default="scope">
                            {{ scope.row.operationType === 1 ? '入柜' : '出柜' }}
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount" :disabled="loading">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getKeepSampleList } from "@/api/sample";

export default {
    name: 'DeviceRecordManagement',
    data() {
        return {
            searchForm: {
                deviceId: ''
            },
            deviceRecordList: [], // 表格展示数据
            originalList: [],      // 原始全量数据
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            loading: false
        };
    },
    mounted() {
        this.loadAllData();
    },
    // 🔥 修复：这里是 methods = {}
    methods: {
        // 1. 加载全部数据
        async loadAllData() {
            if (this.loading) return;
            this.loading = true;
            try {
                // 请求所有数据
                const res = await getKeepSampleList({ pageNo: 1, pageSize: 9999 });
                if (res.data.records) {
                    this.originalList = res.data.records;
                } else if (res.data.list) {
                    this.originalList = res.data.list;
                } else if (Array.isArray(res.data)) {
                    this.originalList = res.data;
                }
                // 渲染数据
                this.search();
            } catch (err) {
                console.error("加载数据失败", err);
                this.$message.error("数据加载失败");
            } finally {
                this.loading = false;
            }
        },

        // 2. 前端模糊查询 + 分页
        search() {
            let dataList = [...this.originalList];
            const keyword = (this.searchForm.deviceId || "").trim();

            // 设备序列号模糊过滤
            if (keyword) {
                dataList = dataList.filter(item => {
                    return item.deviceId && item.deviceId.includes(keyword);
                });
            }

            // 分页处理
            this.totalCount = dataList.length;
            const start = (this.currentPage - 1) * this.pageSize;
            const end = this.currentPage * this.pageSize;
            this.deviceRecordList = dataList.slice(start, end);
        },

        // 查询按钮
        getTemplateList() {
            this.currentPage = 1;
            this.search();
        },

        // 重置
        resetSearch() {
            this.searchForm.deviceId = "";
            this.currentPage = 1;
            this.search();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.search();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.search();
        },

        handleRowClick(row) {
            this.$refs.tableRef.toggleRowSelection(row);
        }
    }
};
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}
</style>